export default __webpack_public_path__ + "static/media/position.0384fe12.svg";